import type { Player } from '@dicetechnology/doris-core';
import type { LoadRequestData } from 'chromecast-caf-receiver/cast.framework.messages';

import { tryParseDate } from './tryParseDate';

export const configureLimitSeekableRangePlugin = async (player: Player, loadRequest: LoadRequestData): Promise<void> => {
    const LIMIT_SEEKABLE_RANGE_PLUGIN_NAME = 'lsr';

    const seekableRangeLimits = loadRequest.customData?.seekableRangeLimits;

    if (!seekableRangeLimits) {
        return;
    }

    loadRequest.media.customData.seekableRangeLimits = {
        start: tryParseDate(seekableRangeLimits.start),
        end: tryParseDate(seekableRangeLimits.end)
    };

    if (player.getPluginByName(LIMIT_SEEKABLE_RANGE_PLUGIN_NAME)) {
        return;
    }

    const { LimitSeekableRangePlugin } = await import('@dicetechnology/doris-plugin-limit-seekable-range');

    const existingPlugin = player.getPluginByType(LimitSeekableRangePlugin);
    if (!existingPlugin) {
        player.addPlugin({
            name: LIMIT_SEEKABLE_RANGE_PLUGIN_NAME,
            Plugin: LimitSeekableRangePlugin
        });
    }
};
